import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import { tableData} from './data'
import './index.scss'
import {message, Modal,Button} from 'antd'
import {getScoreList,downloadScore} from "../../../../servers/province";
import {withRouter} from "react-router-dom";
import store from "../../../../redux";


@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
    this.getAlertSelect = this.getAlertSelect.bind(this)
    this.exportData = this.exportData.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // reload时重新加载数据
    // this.getListData();
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    copydata:[],
    page: tableData.tPage,
    loading: false,
    current:0
  };

  exportData() {
    const result = JSON.parse(localStorage.getItem('userList'))
    const params = {
      museumid: result.museumid?result.museumid:store.getState().libraryid,
      annual: result.annual
    }
    downloadScore(params).then(res => {
      if (res.statecode === 0) {
        window.open(res.records[0].url,'_blank')
      } else {
        message.error('导出失败')
      }
    })
  }


  getAlertSelect(data){
    if (data === 0) {
      this.setState({
        dataSource:this.state.copydata,
        current:data
      })
      return
    }
    const result = []
    this.state.copydata.forEach(item=>{
      if (item.rank <= data) {
        result.push(item)
      }
    })
    this.setState({
      dataSource:result,
      current:data
    })
  }

  // 获取用户列表数据
  getListData(){
    this.setState({
      loading: true
    });
    const result = JSON.parse(localStorage.getItem('userList'))
    const params = {
      museumid:result.museumid?result.museumid:store.getState().libraryid,
      annual:result.annual
    }
    getScoreList(params).then(res=>{
      if (res.records.length>0){
        let data =JSON.parse(JSON.stringify(res.records))
        let total = 1;
        const num = data[0].tables[0].tabhead.length
        for (let key = 0; key < num ;key++){
          tableData.tHead.push(
              {
                key: 'col'+key,
                dataIndex: 'col'+key,
                title: 'index',
                slot:key === 0 ? 'index':'',
                width: key === 0? 50:100
              },
          )
          tableData.tHead[key].title = data[0].tables[0].tabhead[key]
        }
        const Header = tableData.tHead.slice(0,num)
        this.setState({
          columns: Header,
          copydata:data[0].tables[0].tabbody,
          dataSource: data[0].tables[0].tabbody,
          page: {...this.state.page, total},
          loading: false
        });
      } else {
        message.error(res.statemessage)
        this.setState({
          loading: false
        });
      }

    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  componentDidMount(){
    store.subscribe(() => {
      const state = store.getState()
      if (state.libraryname){
        const result = JSON.parse(localStorage.getItem('userList'))
        const museumid = store.getState().libraryid
        this.setState({
          year:result.annual,
          museumid:museumid,
        },()=>{
          this.getListData();
        })
      }
    })
    this.getListData();
  }
  render(){
    return (
        <div className='user-manage-list'>
          <div className='search-btn'>
            <div>
            <Button className={this.state.current === 0 ? 'scoreCurrent' : ''} type='primary' size="mini" onClick={() => this.getAlertSelect(0)} style={{marginRight:'20px'}}>
              全部
            </Button>
            <Button className={this.state.current === 4 ? 'scoreCurrent' : ''} type='primary' size="mini" onClick={() => this.getAlertSelect(4)} style={{marginRight:'20px'}}>
              四级及以上
            </Button>
            <Button className={this.state.current === 3 ? 'scoreCurrent' : ''} type='primary' size="mini" onClick={() => this.getAlertSelect(3)} style={{marginRight:'20px'}}>
              三级及以上
            </Button>
            <Button className={this.state.current === 2 ? 'scoreCurrent' : ''} type='primary' size="mini" onClick={() => this.getAlertSelect(2)} style={{marginRight:'20px'}}>
              二级及以上
            </Button>
            <Button className={this.state.current === 1 ? 'scoreCurrent' : ''} type='primary' size="mini" onClick={() => this.getAlertSelect(1)} style={{marginRight:'20px'}}>
              一级
            </Button>
            </div>
            <Button style={{textAlign:'right'}} type='primary' size="mini" onClick={() => this.exportData(2)} style={{marginRight:'20px'}}>
              导出
            </Button>
          </div>
          <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns} dataSource={this.state.dataSource} onTableChange={this.onTableChange}>
            <div
                slot='index'
                render={(text, record, index) => (
                    <div className='operate'>
                      {index+1}
                    </div>
                )} />
          </CTable>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
